import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/axios'
import './plugins/bootstrap-vue'
import './plugins/fontawesome'
import App from './App.vue'
import store from './store'
import i18n from './i18n/i18n'
import router from './router'
import moment from 'moment'
import momentLocaleRu from 'moment/locale/ru'
import ModalMixin from './mixins/modal';
import EventBus from './event/event-bus';
//import VueAnalytics from 'vue-analytics';
// import Hotjar from 'vue-hotjar'
//import VueIntercom from 'vue-intercom';
// import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import ContainerLoader from '@/components/ContainerLoader';
import VueGtag from "vue-gtag";
import LocalStorage from "./libs/LocalStorage";
//Vue.use(VueFacebookPixel)

moment.locale('en', {
  relativeTime: {
    future: 'in %s',
    past: function(val) {
      if (val === 'recently') {
        return val;
      }

      return val + ' ago';
    },
    s:  'recently',
    ss: '%ss',
    m:  '%dm.',
    mm: '%dm',
    h:  '%dh',
    hh: '%dh',
    d:  '%dd',
    dd: '%dd',
    M:  '%dmo.',
    MM: '%dmo.',
    y:  '%dy',
    yy: '%dy'
  }
});
const initalLocale = LocalStorage.getValue(LocalStorage.LOCALE_KEY) || 'ru';
moment.locale(initalLocale, momentLocaleRu);
moment.locale(initalLocale);

Vue.prototype.moment = moment;
Vue.config.productionTip = false;

Vue.mixin(ModalMixin);
Vue.component('container-loader', ContainerLoader);

window.orgCurrencyEntity = window.orgCurrencyEntity ? window.orgCurrencyEntity : '$';

//Register global instance for old JavaScript code
window.eventBus = EventBus;

// Configuration VueAnalytics
// Vue.use(VueAnalytics, {
//   id: 'G-TEHHZPKXMV',
//   router
// });
Vue.use(VueGtag, {
  config: { id: "G-TEHHZPKXMV" }
});

//
// Vue.use(Hotjar, {
//   id: '1829997', // Hotjar Site ID
//   snippetVersion: 6
// })
// Vue.use(VueIntercom, { appId: 'xfmr2av7' });

new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app');
